import { overlay } from '@shared/ui/overlay';

import { AlertDialog, type AlertDialogProps } from './alert-dialog.ui';

export type OpenAlertDialogOptions = Omit<
  AlertDialogProps,
  'open' | 'defaultOpen' | 'onOpenChange' | 'onConfirm' | 'onCancel' | 'inline' | 'status'
>;

/**
 * 명령형 확인 창(파운데이션 `overlay.open` 위). 확인 → true, 취소 · Esc · 다른 곳에서 닫힘 → false.
 *
 *   if (await openAlertDialog({ title: '정말 삭제할까요?', tone: 'danger' })) remove();
 */
export async function openAlertDialog(options: OpenAlertDialogOptions): Promise<boolean> {
  const result = await overlay.open<boolean>(({ close }) => (
    <AlertDialog
      {...options}
      open
      onOpenChange={(next) => {
        if (!next) close(false);
      }}
      onConfirm={() => close(true)}
    />
  ));
  return result === true;
}
